import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as teamApi from "../services/teamService";

const rows = (payload, key) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.[key])) return payload[key];
  if (Array.isArray(payload?.items)) return payload.items;
  return [];
};

export const fetchTeamAsync = createAsyncThunk("team/fetch", async () => {
  const [members, invitations] = await Promise.all([
    teamApi.getTeamMembers(),
    teamApi.getTeamInvitations(),
  ]);
  return { members: rows(members, "members"), invitations: rows(invitations, "invitations") };
});
export const inviteTeamMemberAsync = createAsyncThunk("team/invite", async (body) => teamApi.inviteTeamMember(body));
export const updateTeamMemberAsync = createAsyncThunk("team/update", async ({ userId, body }) => teamApi.updateTeamMember(userId, body));
export const removeTeamMemberAsync = createAsyncThunk("team/remove", async (userId) => {
  await teamApi.removeTeamMember(userId);
  return userId;
});
export const revokeTeamInvitationAsync = createAsyncThunk("team/revokeInvitation", async (invitationId) => {
  await teamApi.revokeTeamInvitation(invitationId);
  return invitationId;
});

const slice = createSlice({
  name: "team",
  initialState: { members: [], invitations: [], loading: false, error: null, loaded: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamAsync.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchTeamAsync.fulfilled, (state, action) => {
        state.loading = false; state.loaded = true;
        state.members = action.payload.members; state.invitations = action.payload.invitations;
      })
      .addCase(fetchTeamAsync.rejected, (state, action) => {
        state.loading = false; state.loaded = true; state.error = action.error?.message || "Unable to load team.";
      })
      .addCase(inviteTeamMemberAsync.fulfilled, (state, action) => {
        const invitation = action.payload?.invitation || action.payload;
        if (invitation?.invitation_id) state.invitations.unshift(invitation);
      })
      .addCase(updateTeamMemberAsync.fulfilled, (state, action) => {
        const member = action.payload?.member || action.payload;
        if (!member?.user_id) return;
        const index = state.members.findIndex((item) => item.user_id === member.user_id);
        if (index >= 0) state.members[index] = member;
      })
      .addCase(removeTeamMemberAsync.fulfilled, (state, action) => {
        state.members = state.members.filter((item) => item.user_id !== action.payload);
      })
      .addCase(revokeTeamInvitationAsync.fulfilled, (state, action) => {
        state.invitations = state.invitations.filter((item) => item.invitation_id !== action.payload);
      });
  },
});

export default slice.reducer;
